import SafeArea from "@/components/safe-area";
import Skeleton from "@/components/skeleton/Skeleton";

export default function FooterBtnSkeleton() {
	return (
		<div className="flex-shrink-0">
			<Skeleton className="w-full h-12 rounded-full" />
			<div className="h-6" />
			<SafeArea position="bottom" />
		</div>
	);
}
